export const ours = 'https://api.sdn104.iflex.ru';
export const prod = 'https://api.miloserdieapp.ru';
